import React from 'react';
import './ui.css';

// A progress bar with a real role and the percentage written out, so it does
// not depend on colour or on seeing the bar.
export default function ProgressBar({ value, label }) {
  const pct = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  return (
    <div className="progress">
      <div
        className="progress-track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label={label || 'Progress'}
      >
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="progress-text">{pct}%</span>
    </div>
  );
}
